module.exports = __webpack_public_path__ + "static/media/tournetachance.8887a6ac.png";